import create from "zustand"
import { persist } from "zustand/middleware"

const initialState = {
  user: {},
  changes: false,
  modificacion: false,
  consulta: false,
  admin: false,
  solicitudes: [],
  idTitular: "",
  solicitud: null,
  propuestaEditable: null,
  otorgamientoEditable: null,
  accionesSolicitud: null,
  idAccionWorkflow: null,
  fvencimientoCalificacion: null,
  permisos: [],
  loading: true,
  cuit: "",
  razonSocial: "",
  modalSave: false,
  pagePosition: null,
  searchParamsSolicitud: {
    cuit: "",
    dictamenes: [],
    fechaDictamen: null,
    fechaDesde: null,
    fechaHasta: null,
    nombre: "",
    nroSolicitud: 0,
    nivel: 0,
    estado: "",
    sucursal: 0,
    oficialComercial: "",
  },
  catalogos: [],
}

const userStore = create(
  persist(
    set => ({
      ...initialState,
      setHandleChangeSave: (e, handleChange) => {
        set({ changes: true })
        handleChange(e)
      },
      setUser: user => set({ user: user }),
      setCatalogos: catalogos => set({ catalogos: catalogos }),
      removeUser: () => set({ user: false }),
      setChanges: () => set({ changes: true }),
      reset: () => set({ ...initialState }),
    }),
    {
      name: "user",
      getStorage: () => localStorage,
      partialize: state =>
        Object.fromEntries(
          Object.entries(state).filter(([key]) => key !== "loading"),
        ),
    },
  ),
)

export default userStore
